// Lib
import React from 'react';

// Components
import CountButton from '../../../../Button/CountButton';

// Hooks
import useCountComponent from './useCountComponent';
import { useStyles } from './CountComponentStyles';

const CountComponent = ({ orderItem, product, order, isGridView = false }) => {
  const { classes } = useStyles({ isGridView });
  const { onAdd, onRemoveOne, onSetCount, onRemoveProductWithZeroCount } =
    useCountComponent(order, orderItem, product);

  return (
    <CountButton
      className={classes.button}
      product={product}
      count={orderItem?.qty_ordered}
      onAdd={onAdd}
      onSetCount={onSetCount}
      onRemove={onRemoveOne}
      onClickAway={onRemoveProductWithZeroCount}
    />
  );
};

export default CountComponent;
